import React, { Component, useState } from 'react';
import { FormattedMessageWrappedInSpan } from '../../../components/misc';



const JobDeveloperCSharp = ({setShowJob, showJob, job, ...props}) => {

  return (
    <>
    { job == "developerCSharp" &&
    <div className="container-960 container-page">
      <h2>
        <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.headline" defaultMessage="Placeholder" />
      </h2>
      <br />
      <br />
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.aboutus.title" defaultMessage="Placeholder" />
      </b>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.developerCSharp.aboutus.text"
          defaultMessage="Placeholder"
          values={{
            br: <br />,
          }}
        />
      </p>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.yourroll.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.yourroll.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.yourroll.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.yourroll.bullet3" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.bullet3" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.bullet4" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.bullet5" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.bullet6" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.bullet7" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.needs.bullet8" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.bullet3" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.bullet4" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.bullet5" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.bullet6" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.bullet7" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.offer.bullet8" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.developerCSharp.contact.title" defaultMessage="Placeholder" />
      </b>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.developerCSharp.contact.contact"
          defaultMessage="Placeholder"
        />
      </p>
      <br />
      <button className="secondary" onClick={() => setShowJob(!showJob)}>
        <FormattedMessageWrappedInSpan
          id="jobsPage.back"
          defaultMessage="back"
        />
      </button>
      </div>
            }
      </>
  )
}

export default JobDeveloperCSharp
